import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { z } from 'zod';
import { WeekType } from 'src/types/domain.types';
import { useGetContestQuery } from '../contests/getContest';

export const CreateRoundValidationSchema = z.object({
  name_en: z.string().min(1),
  start_utc: z.string(),
  end_utc: z.string(),
  matches: z.array(z.object({ match_id: z.number() })),
  status: z.number(),
});

const createRound = (round: WeekType, contestId: number) =>
  api.post(`/contests/${contestId}/weeks`, round, {
    validateStatus: (status) => status < 500,
  });

export const useCreateRoundMutation = (contestId: number) => {
  const { refetch } = useGetContestQuery(contestId);

  return useMutation({
    mutationKey: ['create-round', contestId],
    mutationFn: (round: WeekType) => createRound(round, contestId),
    onSuccess: () => {
      toast.success('Round created successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error); // catch error in ErrorBoundary
    },
  });
};
